import { useContext } from 'react';

import Text from 'components/common/Text';
import { UserContext } from 'components/signUpFunnel/Contexts';

const FamilyPlanHeader = ({ box }) => {
  const { user } = useContext(UserContext);
  const hasSmsDiscount = user?.smsDiscount && box?.smsIncentivePromo;

  let promoHeaderText;
  if (box?.promoApplied && hasSmsDiscount) {
    promoHeaderText = `${box?.promo.displayedDiscount} + 5% SMS DISCOUNT`;
  } else if (box?.promoApplied) {
    promoHeaderText = `${box?.promo.displayedDiscount} this box ${box?.promo.maxDiscount ? `(up to ${box?.promo.maxDiscount})` : ''}`;
  } else if (hasSmsDiscount) {
    promoHeaderText = '5% SMS DISCOUNT APPLIED';
  } else {
    promoHeaderText = null;
  }

  let subtotalContent;
  if (box?.promoApplied) {
    subtotalContent = (
      <Text htmlElement="span">
        <Text htmlElement="span" className="mr-2" brandStylesOverrides="h2 text-primary">
          {box?.promo.subtotalFormatted}
        </Text>
        <Text htmlElement="span" className="font-medium text-charcoal-80 line-through">
          {box?.subtotalFormatted}
        </Text>
      </Text>
    );
  } else if (hasSmsDiscount) {
    subtotalContent = (
      <Text htmlElement="span">
        <Text htmlElement="span" className="mr-2" brandStylesOverrides="h2 text-primary">
          {box?.smsIncentivePromo.subtotalFormatted}
        </Text>
        <Text htmlElement="span" className="font-medium text-charcoal-80 line-through">
          {box?.subtotalFormatted}
        </Text>
      </Text>
    );
  } else {
    subtotalContent = <Text brandStylesOverrides="h2 text-primary">{box?.subtotalFormatted}</Text>;
  }

  return (
    <>
      {promoHeaderText && (
        <Text brandStylesOverrides="h7 text-secondary" className="m-0 uppercase">
          {promoHeaderText}
        </Text>
      )}
      {subtotalContent}
    </>
  );
};

FamilyPlanHeader.propTypes = {
  box: PropTypes.shape({
    promoApplied: PropTypes.bool.isRequired,
    promo: PropTypes.shape({
      subtotalFormatted: PropTypes.string,
      pricePerServingFormatted: PropTypes.string,
      displayedDiscount: PropTypes.string,
      maxDiscount: PropTypes.string,
    }),
    subtotalFormatted: PropTypes.string,
    smsIncentivePromo: PropTypes.shape({
      subtotalCents: PropTypes.number,
      subtotalFormatted: PropTypes.string,
    }),
  }).isRequired,
};

export default FamilyPlanHeader;
